<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <path
      d="M11.6666 11.6667H22.3333C23.0666 11.6667 23.6666 12.2667 23.6666 13V21C23.6666 21.7333 23.0666 22.3333 22.3333 22.3333H11.6666C10.9333 22.3333 10.3333 21.7333 10.3333 21V13C10.3333 12.2667 10.9333 11.6667 11.6666 11.6667Z"
      stroke="#FF8A71"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.6666 13L17 17.6667L10.3333 13"
      stroke="#FF8A71"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
